import { ResponsiveContainer, AreaChart, Area } from 'recharts';

export const MiniSparkline = ({ data = [], color, dataKey = 'y', height = 44 }) => {
  const stroke = color || 'var(--tenant-accent-500)';
  const id = `spark-${Math.random().toString(36).slice(2, 8)}`;
  if (!data.length) return <div style={{ height }} />;
  return (
    <div style={{ height }} data-testid="kpi-card-sparkline">
      <ResponsiveContainer width="100%" height="100%" minWidth={0}>
        <AreaChart data={data} margin={{ top: 4, right: 0, bottom: 0, left: 0 }}>
          <defs>
            <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={stroke} stopOpacity={0.28} />
              <stop offset="100%" stopColor={stroke} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area type="monotone" dataKey={dataKey} stroke={stroke} strokeWidth={2} fill={`url(#${id})`} isAnimationActive={false} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
